// src/context/CartContext.jsx
import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (item) => {
    setCartItems((prev) => {
      const existingIndex = prev.findIndex((i) => i.name === item.name);
      if (existingIndex !== -1) {
        return prev.map((i, idx) =>
          idx === existingIndex ? { ...i, quantity: i.quantity + 1 } : i
        );
      } else {
        return [...prev, { ...item, quantity: 1 }];
      }
    });
  };
  
  const incrementQuantity = (index) => {
    setCartItems((prev) => {
      return prev.map((item, i) => {
        if (i === index) {
          return { ...item, quantity: item.quantity + 1 }; 
        }
        return item;
      });
    });
  };
  
  
  const decrementQuantity = (index) => {
    setCartItems((prev) => {
      return prev.flatMap((item, i) => {
        if (i !== index) return item;
        if (item.quantity > 1) {
          return { ...item, quantity: item.quantity - 1 }; // ✅ reduce quantity
        }
        return []; // ✅ remove item if quantity reaches 0
      });
    });
  };
  
  

  const removeFromCart = (index) => {
    setCartItems((prev) => prev.filter((_, i) => i !== index));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const total = cartItems.reduce((sum, item) => sum + item.value * item.quantity, 0);

  return (
    <CartContext.Provider value={{ cartItems, addToCart,incrementQuantity,decrementQuantity, removeFromCart, clearCart, total }}>
      {children}
    </CartContext.Provider>
  );
};
